@if (pageReady) {
  <main class="gs-page">
    <img class="gs-outage-logo" [src]="pageLabels.gsLogo" [alt]="pageLabels.imageAltText" />
    <div class="gs-page-inner">
      <div class="outage-text-container">
        <h1 class="main-header" [innerHTML]="pageLabels.mainHeader"></h1>
        <p class="sub-header-text" [innerHTML]="pageLabels.subHeader"></p>
        <p class="call-text" [innerHTML]="pageLabels.needHelpText"></p>
      </div>
      <div class="customer-care-container">
        <p class="customer-care-title" [innerHTML]="pageLabels.customerCareTitle"></p>
        <p class="customer-care-hours" [innerHTML]="pageLabels.customerCareHours"></p>
      </div>
      <div class="home-button">
        <p class="home-description" [innerHTML]="pageLabels.returnHomeText"></p>
        <a
          class="gs-link-btn"
          color="primary"
          [routerLink]="pageLabels.ctaLink.url"
          [innerHTML]="pageLabels.ctaLink.linkText"
          [attr.aria-label]="pageLabels.ctaLink.ariaLabel"
        ></a>
      </div>
    </div>
  </main>
}
